import { useEffect, useMemo, useState } from "react";
import { useLocation } from "react-router-dom";
import { LocalStorageHelpers } from "../../../utils/helpers/localstorage.helpers";

export const useOnboardingCheck = () => {
  const location = useLocation();
  const [showOnboarding, setShowOnboarding] = useState(false);

  const userRole = useMemo<"agent" | "agency">(() => {
    const storedRole = LocalStorageHelpers.getSessionUserType();
    return storedRole === "agent" || storedRole === "agency"
      ? storedRole
      : "agency";
  }, []);

  useEffect(() => {
    if (userRole !== "agency") {
      setShowOnboarding(false);
      return;
    }

    const agencyData = LocalStorageHelpers.getAgencyData();

    if (location.state && (location.state as any).showOnboarding) {
      setShowOnboarding(true);
      window.history.replaceState({}, document.title);
      return;
    }

    setShowOnboarding(agencyData?.dashboard_onboarding === "pending");
  }, [location.pathname, userRole]);

  const closeOnboarding = () => setShowOnboarding(false);

  return {
    showOnboarding,
    closeOnboarding,
    userRole,
  };
};